'use client';

export default function IconSvg({ id }: { id: string }) {
  return (
    <svg className="w-full h-full block">
      <use xlinkHref={`#${id?.replace(/(-usage)$/, '')}`}></use>
    </svg>
  );
}
